import dayjs from 'dayjs';

export interface ChangeDetail {
    field: string;
    value: string;
}

const fmtDate = (val: string | null | undefined): string => {
    if (!val) return 'Evergreen';
    const d = dayjs(val.split('T')[0]);
    return d.isValid() ? d.format('DD MMM YYYY') : 'Evergreen';
};

const norm = (v: any): string => (v === null || v === undefined ? '' : String(v).trim());

/**
 * Compare common program fields and return { field, value } entries where value = NEW value.
 * Old values are not included — only what changed and what it changed TO.
 */
export function detectCommonChanges(
    initial: Record<string, any>,
    submitted: {
        trainingName?: string;
        startDate?: string;
        endDate?: string;
        isEvergreen?: boolean;
        passingPercentage?: number | string;
        estimatedEffortHours?: number | string;
        trainingType?: string;
        trainingLink?: string;
    }
): ChangeDetail[] {
    const changes: ChangeDetail[] = [];

    if (submitted.trainingName !== undefined && norm(submitted.trainingName) !== norm(initial.trainingName)) {
        changes.push({ field: 'Program Name', value: submitted.trainingName! });
    }

    const oldStart = fmtDate(initial.startDate);
    const newStart = submitted.isEvergreen ? 'Evergreen' : fmtDate(submitted.startDate);
    if (oldStart !== newStart) {
        changes.push({ field: 'Start Date', value: newStart });
    }

    const oldEnd = fmtDate(initial.endDate);
    const newEnd = submitted.isEvergreen ? 'Evergreen' : fmtDate(submitted.endDate);
    if (oldEnd !== newEnd) {
        changes.push({ field: 'End Date', value: newEnd });
    }

    if (submitted.passingPercentage !== undefined && norm(submitted.passingPercentage) !== norm(initial.passingPercentage)) {
        changes.push({ field: 'Passing %', value: `${submitted.passingPercentage}%` });
    }

    if (submitted.estimatedEffortHours !== undefined && norm(submitted.estimatedEffortHours) !== norm(initial.estimatedEffortHours)) {
        changes.push({ field: 'Effort Hours', value: `${submitted.estimatedEffortHours} hrs` });
    }

    if (submitted.trainingType !== undefined && norm(submitted.trainingType) !== norm(initial.trainingType)) {
        changes.push({ field: 'Training Type', value: submitted.trainingType! });
    }

    const oldLink = norm(initial.trainingLink);
    const newLink = norm(submitted.trainingLink);
    if (oldLink !== newLink && oldLink !== 'N/A' && newLink !== 'N/A') {
        const status = !oldLink ? 'Added' : !newLink ? 'Removed' : 'Updated';
        changes.push({ field: 'Resource Link', value: status });
    }

    return changes;
}
